import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React from 'react';
import HeaderNavigationItem from './HeaderNavigationItem';

const HeaderNavigationMoreItem = dynamic(
  () => import('./HeaderNavigationMoreItem'),
  {
    ssr: false,
  },
);

const HeaderNavigation = ({ isMobile, navigation }) => {
  const navigationItems = isMobile ? navigation : navigation.slice(0, 10);

  return (
    <>
      <div className="nav-bar">
        <nav className="container">
          <ul className="navigation__list">
            {navigationItems.map((item) => (
              <HeaderNavigationItem
                key={item.id}
                name={item.linkText}
                path={item.url}
              />
            ))}
            {!isMobile && <HeaderNavigationMoreItem navigation={navigation} />}
          </ul>
        </nav>
      </div>

      <style jsx>{`
        .nav-bar {
          position: relative;
          background-color: #f0f0f0;
          border-bottom: 1px solid #d2d2d2;
          border-top: 1px solid #d2d2d2;
          display: block;
          z-index: 1001;
        }
        .container {
          position: relative;
          z-index: 100;
          padding: 0 25px;
          display: flex;
        }
        .navigation__list {
          display: flex;
          flex-grow: 1;
          justify-content: space-between;
          height: 36px;
          margin: 0;
          padding: 0;
        }
        @media (max-width: 767.98px) {
          .container {
            padding: 0;
            overflow: auto;
          }
        }
      `}</style>
    </>
  );
};

HeaderNavigation.propTypes = {
  isMobile: PropTypes.bool,
  navigation: PropTypes.array,
};

export default HeaderNavigation;
